import { MessageCircle } from "lucide-react";
import { LogoMark } from "./Logo";
import { NAV, LOCATIONS, OWNER, PHONE_DISPLAY, PHONE_TEL, WA_DEFAULT } from "../../lib/site";
import { scrollToId } from "../../lib/scroll";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-[#080B11] pt-20 pb-10">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <LogoMark className="h-11 w-11" />
          <p className="mt-5 max-w-xs text-sm text-slate-400">Premium, flexible co-working spaces in Noida for freelancers, startups and corporate teams.</p>
        </div>
        <div className="grid grid-cols-2 gap-2 text-sm">
          {NAV.map(([id, label]) => (
            <button key={id} onClick={() => scrollToId(id)} data-testid={`footer-link-${id}`} className="text-left text-slate-300 hover:text-[#E3C45A] transition-colors py-1">{label}</button>
          ))}
        </div>
        <div className="space-y-3 text-sm text-slate-300">
          <p className="text-white">{OWNER}</p>
          <a href={PHONE_TEL} className="block hover:text-[#E3C45A]" data-testid="footer-call">{PHONE_DISPLAY}</a>
          {LOCATIONS.map((l) => <p key={l.id}>{l.name}, {l.area}</p>)}
        </div>
      </div>
      <p aria-hidden="true" className="font-display mt-20 select-none whitespace-nowrap text-[17vw] lg:text-[12.5rem] font-bold leading-[0.8] tracking-[-0.05em] text-outline">Kinara Works</p>
      <div className="mt-10 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-slate-400 sm:flex-row sm:justify-between">
        <p>© {new Date().getFullYear()} Kinara Works. All rights reserved.</p>
        <p>Sector 132 · Sector 90 · Noida, Uttar Pradesh</p>
      </div>
    </div>
  </footer>
);

export const WhatsAppFab = () => (
  <a href={WA_DEFAULT} target="_blank" rel="noreferrer" aria-label="Chat on WhatsApp" data-testid="whatsapp-floating-btn"
    className="fixed bottom-5 right-5 z-40 grid h-14 w-14 place-items-center rounded-full bg-emerald-500 text-[#04120B] shadow-[0_15px_40px_-10px_rgba(16,185,129,.7)] transition-transform hover:scale-110">
    <span className="absolute inset-0 rounded-full bg-emerald-500 animate-ping opacity-25" />
    <MessageCircle className="relative h-6 w-6" />
  </a>
);
